import React from 'react';
import { compose } from 'redux';
import { WIDGETS_MAPPER } from "./widgetsMapper";
import { WIDGETS_MAPPER_V2 } from "./widgetMapperV2";
import LayoutComponent from "../../Components/Layout/Layout";
import NavigationHeader from "../../Components/NavigationHeader/NavigationHeader";
import { connect } from 'react-redux';
import { getTrackingOrigin } from "../../Store/Selectors/layout";
import useTracker from "../../CustomHooks/useTracker/useTracker";
import { TRACKING_ORIGINS } from "../../Constants/trackingEvents";
import withConfig from "../../ComponentDependency/withConfig";
export var OLXAutosHomePage = function OLXAutosHomePage(_ref) {
  var layout = _ref.layout,
    track = _ref.track,
    locationId = _ref.locationId,
    origin = _ref.origin,
    variant = _ref.variant,
    userIsLogged = _ref.userIsLogged,
    omittedCxeWidget = _ref.omittedCxeWidget,
    omittedCxeSection = _ref.omittedCxeSection,
    handleCallbackClick = _ref.handleCallbackClick,
    handleIconClick = _ref.handleIconClick,
    config = _ref.config,
    browsingMode = _ref.browsingMode,
    onItemView = _ref.onItemView,
    isMxCl = _ref.isMxCl,
    landingURLSearch = _ref.landingURLSearch,
    location = _ref.location,
    disclaimer = _ref.disclaimer;
  useTracker({
    layout: layout,
    track: track,
    browsingMode: TRACKING_ORIGINS.OLX_AUTOS_HOME,
    locationId: locationId,
    origin: origin,
    config: config
  });
  var metadata = layout.metadata;
  return /*#__PURE__*/React.createElement(React.Fragment, null, metadata && metadata.navigationHeader && /*#__PURE__*/React.createElement(NavigationHeader, Object.assign({}, metadata.navigationHeader)), /*#__PURE__*/React.createElement(LayoutComponent, {
    sections: layout.sections,
    WIDGETS_MAPPER: WIDGETS_MAPPER,
    WIDGETS_MAPPER_V2: WIDGETS_MAPPER_V2,
    omittedCxeWidget: omittedCxeWidget,
    omittedCxeSection: omittedCxeSection,
    track: track,
    locationId: locationId,
    variant: variant,
    userIsLogged: userIsLogged,
    handleIconClick: handleIconClick,
    handleCallbackClick: handleCallbackClick,
    origin: origin,
    browsingMode: browsingMode,
    onItemView: onItemView,
    isMxCl: isMxCl,
    landingURLSearch: landingURLSearch,
    location: location,
    disclaimer: disclaimer
  }));
};
export var mapStateToProps = function mapStateToProps(state, props) {
  return {
    origin: getTrackingOrigin(state, props.location, props.config),
    browsingMode: state.track.browsingMode,
    landingURLSearch: state.track.landingURLSearch
  };
};
export default compose(withConfig, connect(mapStateToProps))(OLXAutosHomePage);